export default __webpack_public_path__ + "static/media/space.06974f78.png";